import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageableResponse } from 'src/@core/interfaces/pageable-response';
import { CRETE_ROLE_WITH_PERMISSIONS, FETCH_PERMISSIONS } from 'src/@core/services/util/api.endpoints';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class RolesPermissionsService {

  constructor(
    private http: HttpClient
  ) { }

  // fetch Permissions
  fetchPermissions(entityType?: string) {
    let url = FETCH_PERMISSIONS;
    if (entityType) {
      url += '?entityType=' + entityType;
    }
    return this.http.get<any>(url);
  }

  // add Permissions
  addPermissions(payload: any) {
    let url = FETCH_PERMISSIONS;
    return this.http.post<any>(url, payload);
  }

  // fetch roles with permissions
  // fetchRolesWithPermissions(entityType?: string) {
  //   let url = CRETE_ROLE_WITH_PERMISSIONS;
  //   if (entityType) {
  //     url += '?entityType=' + entityType;
  //   }
  //   return this.http.get<any>(url);
  // }

  fetchRolesWithPermissions(entityType: any, page: number, size: number, sort: string, order: string, searchList?: any[]): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (entityType) {
      url = CRETE_ROLE_WITH_PERMISSIONS + '/' + entityType + '?page=' + page;
    } else {
      url = CRETE_ROLE_WITH_PERMISSIONS + '?page=' + page;
    }
    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  // create Role With Permissions
  createRoleWithPermissions(params, id) {
    let url = CRETE_ROLE_WITH_PERMISSIONS;
    if (id) {
      url = CRETE_ROLE_WITH_PERMISSIONS + '/' + id;
      return this.http.put<any>(url, params);
    } else {
      return this.http.post<any>(url, params);
    }
  }
}
